import {
  Box,
  Grid,
  Hidden,
  InputAdornment,
  Typography,
} from "@material-ui/core";
import InvestorDetailsPreview from "../../InvestorDetails";
import SubmitButton from "../../../../forms/formik/FormSubmitButton";
import CustomButton from "../../../../forms/CustomButton";
import { Form, Formik } from "formik";
import FormAutoComplete, {
  FormSelect,
} from "../../../../forms/formik/FormSelectField";
import FormTextInput from "../../../../forms/formik/FormTextInput";
import useSip from "./useSip";

import {
  EXISTING,
  EXISTINGP,
  NEW,
  NEWP,
  YES,
} from "../../../../../store/types";
import FormRadioButton from "../../../../forms/formik/FormRadioField";
import { PURCHASE_TYPE_OPTIONS } from "../AdditionalPurchase/useAdditionalPurchase";
import { convertToInr } from "../../../../../utils/cart";
import FormCheckbox from "../../../../forms/formik/FormCheckbox";
import {
  maskEmail,
  maskMobileNumber,
  maskPan,
} from "../../../../../utils/utilityFunctions";
import { FAMILY_OPTIONS } from "..";

const Sip = () => {
  const {
    changeHandlers,
    options,
    onSubmit,
    goToCart,
    initialValues,
    isEdit,
    isSipExisting,
    payload,
    validationSchema,
  } = useSip();

  return (
    <Grid container>
      <Grid item lg={9} sm={12}>
        <Box
          sx={{
            margin: "40px",
            bgcolor: "white",
            padding: "36px 64px",
            boxShadow: "0px 0px 8px 0px rgba(202, 202, 202, 1);",
            borderRadius: "4px",
          }}
        >
          <Formik
            initialValues={initialValues}
            onSubmit={onSubmit}
            validationSchema={validationSchema}
            enableReinitialize
            validateOnBlur
          >
            {({ values, setValues }) => {
              const showCategory =
                !isSipExisting ||
                (isSipExisting && values.purchaseType === NEW);
              return (
                <Form>
                  <Typography
                    component={"h4"}
                    style={{
                      fontWeight: "800",
                      fontSize: "24px",
                      marginBottom: "20px",
                      fontFamily: "OpenSans-SemiBold",
                    }}
                  >
                    SIP
                  </Typography>

                  <FormAutoComplete
                    disabled
                    name="fund"
                    label="AMC"
                    placeholder="Select AMC"
                    options={options.amcMasters}
                  />
                  <FormAutoComplete
                    name="sipType"
                    options={options.sipType}
                    label="SIP Type"
                    placeholder="Select SIP Type"
                    disabled
                  />
                  {[EXISTING, EXISTINGP].includes(values.sipType) ? (
                    <FormSelect
                      name="folio"
                      options={options.folios}
                      label="Folio"
                      placeholder="Select Folio"
                      onChange={changeHandlers.handleFolioChange(
                        values,
                        setValues
                      )}
                    />
                  ) : null}

                  {isSipExisting ? (
                    <FormRadioButton
                      label="Scheme Type"
                      name="purchaseType"
                      options={PURCHASE_TYPE_OPTIONS}
                      onChange={changeHandlers.handlePurchaseType(
                        values,
                        setValues
                      )}
                    />
                  ) : null}

                  {showCategory ? (
                    <FormAutoComplete
                      name="category"
                      label="Category"
                      placeholder="Select Category"
                      options={options.categories}
                      onChange={changeHandlers.handleCategoryChange(
                        values,
                        setValues
                      )}
                    />
                  ) : null}

                  <FormAutoComplete
                    name="scheme"
                    label="Scheme"
                    placeholder="Select Scheme"
                    options={options.schemes}
                    onChange={changeHandlers.handleSchemeChange(
                      values,
                      setValues
                    )}
                  />
                  <FormSelect
                    name="modeOfRegistration"
                    options={options.modeOptions}
                    label="Select Mode Of Registration"
                    disabled
                  />
                  {(() => {
                    // @ts-ignore
                    const selectedScheme = options.schemes.find(
                      (scheme: any) => scheme.value === values.scheme
                    );

                    return (
                      selectedScheme &&
                      selectedScheme.combo_flag === YES &&
                      [EXISTINGP, NEWP].includes(values.sipType) && (
                        <FormCheckbox
                          label={selectedScheme.combo_disclaimer}
                          name="combo"
                        />
                      )
                    );
                  })()}
                  <FormAutoComplete
                    name="frequency"
                    label="Select Frequency"
                    options={options.frequencies}
                    onChange={changeHandlers.handleFrequencyChange(
                      values,
                      setValues
                    )}
                  />
                  <Grid container spacing={2}>
                    <Grid item lg={6} sm={12}>
                      <FormTextInput
                        name="noOfInstallments"
                        label={
                          values.minimumInstallments
                            ? `No of Installments (Minimum ${values.minimumInstallments})`
                            : "No of Installments"
                        }
                        type="number"
                        onChange={changeHandlers.handleInstallmentChange(
                          values,
                          setValues
                        )}
                        disabled={!values.frequency || values.perpetual}
                      />
                    </Grid>
                    <Grid item lg={6} sm={12}>
                      <FormSelect
                        name="sipDay"
                        label="Sip Day"
                        options={options.sipDays}
                        onChange={changeHandlers.handleSipDayChange(
                          values,
                          setValues
                        )}
                        disabled={!values.noOfInstallments || values.perpetual}
                      />
                    </Grid>

                    <Grid item lg={6} sm={12}>
                      <FormTextInput
                        disabled
                        name="startDate"
                        label="SIP Start Date"
                      />
                    </Grid>
                    <Grid item lg={6} sm={12}>
                      <FormTextInput
                        disabled
                        name="endDate"
                        label="SIP End Date"
                      />
                    </Grid>
                  </Grid>
                  {values.frequency && values.startDate ? (
                    <Grid item sm={12}>
                      <FormCheckbox
                        name="perpetual"
                        onChange={changeHandlers.handlePerpetual(
                          values,
                          setValues
                        )}
                        label="Perpetual SIP"
                      />
                    </Grid>
                  ) : null}
                  <FormTextInput
                    name="installmentAmount"
                    label={
                      values.sipMinAmount
                        ? `SIP Amount (Minimum${convertToInr(
                            values.sipMinAmount
                          )})`
                        : "SIP Amount"
                    }
                    placeholder="Enter Installment Amount"
                    InputProps={{
                      startAdornment: (
                        <InputAdornment position="start">
                          {"\u20B9"}
                        </InputAdornment>
                      ),
                    }}
                    type="number"
                  />

                  {[NEWP, EXISTINGP].includes(values.sipType) ? (
                    <FormTextInput
                      name="amount"
                      label={
                        values.newPurchaseMinAmount
                          ? `Lumpsum Amount (Minimum ${convertToInr(
                              values.newPurchaseMinAmount
                            )})`
                          : "Lumpsum Amount"
                      }
                      placeholder="Enter Lumpsum Amount"
                      InputProps={{
                        startAdornment: (
                          <InputAdornment position="start">
                            {"\u20B9"}
                          </InputAdornment>
                        ),
                      }}
                      type="number"
                    />
                  ) : null}

                  <Box
                    style={{
                      display: "flex",
                      justifyContent: "center",
                    }}
                  >
                    <CustomButton
                      label="Cancel"
                      variant="outlined"
                      onClick={goToCart}
                    />
                    <SubmitButton
                      label={isEdit ? "Update" : "Add To Cart"}
                      variant="contained"
                    />
                  </Box>
                </Form>
              );
            }}
          </Formik>
        </Box>
      </Grid>
      <Hidden mdDown>
        <Grid item lg={3}>
          <InvestorDetailsPreview
            investorData={[
              { label: "Investor Name", value: payload.investorName },
              { label: "PAN", value: maskPan(payload.pan) },
              { label: "Email", value: maskEmail(payload.email) },
              {
                label: "Email family Description",
                value: FAMILY_OPTIONS.find(
                  ({ value }) => payload.familyEmailFlag === value
                )?.label,
              },
              { label: "Mobile", value: maskMobileNumber(payload.mobile) },
              {
                label: "Mobile family Description",
                value: FAMILY_OPTIONS.find(
                  ({ value }) => payload.familyMobileFlag === value
                )?.label,
              },
              {
                label: "Investor Category",
                value:
                  payload.invCategory === "11"
                    ? "Resident Indian"
                    : payload.invCategory === "20"
                    ? "NRI"
                    : "",
              },

              { label: "ARN Code", value: payload.arnCode },
              { label: "Sub-ARN Code", value: payload.subArn },
              { label: "Sub-Broker Code", value: payload.subBroker },
              {
                label: "EUIN Declaration",
                value: payload.euinDeclaration === "N" ? "Yes" : "No",
              },
              { label: "EUIN Number", value: payload.euin },
            ]}
          />
        </Grid>
      </Hidden>
    </Grid>
  );
};

export default Sip;
